/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';

import ChangePassword from './ChangePassword';
import { ChangePasswordFlowActions } from '../../redux/userFlowActions';
import NavigationActions from '../../redux/NavigationActions';
import { getChangePasswordFlowData, getLoggedInUser, getCurrentPassword } from '../../redux/reduxSelectors';
import { actions as systemNotificationActions } from '../../../redux/ducks/systemNotification';
import SessionService from '../../../../apiServices/SessionService';

import RouteNames from '../../RouteNames';

function mapStateToProps(state, routerProps) {
  const changePasswordFlowData = getChangePasswordFlowData(state);
  const user = getLoggedInUser(state);

  return {
    currentCredentials: {
      email: user.data.email,
      password: getCurrentPassword(state),
    },
    isChangingPassword: changePasswordFlowData.active,
    isMfaEnabled: user.isMfaEnabled(),
    currentPassword: changePasswordFlowData.currentPassword,
    passwordStrength: changePasswordFlowData.passwordStrength,
    newPassword: changePasswordFlowData.newPassword,
    currentPasswordIsValid: changePasswordFlowData.currentPasswordIsValid,
    newPasswordIsValid: changePasswordFlowData.newPasswordIsValid,
    passwordSubmitSuccessful: changePasswordFlowData.passwordSubmitSuccessful,
    goBack: () => {
      NavigationActions.goBackTo(routerProps.history, RouteNames.accountSettings());
      ChangePasswordFlowActions.reset();
    },
    finishPasswordChange: () => {
      NavigationActions.goBackTo(routerProps.history, RouteNames.accountSettings());
      ChangePasswordFlowActions.reset();
    },
    goToPasswordWithMfa: () => {
      NavigationActions.goTo(routerProps.history, RouteNames.changePasswordMfa());
    },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onChangeCurrentPassword: (value) => {
      dispatch(ChangePasswordFlowActions.currentPassword(value));
    },
    onChangeNewPassword: (value, strength) => {
      dispatch(ChangePasswordFlowActions.newPassword(value, strength));
    },
    submitPasswordChange: (callback) => {
      dispatch(ChangePasswordFlowActions.submitPasswords(callback));
    },
    dismissNotification: () => {
      dispatch(systemNotificationActions.dismissNotification());
    },
    verifyCredentials: (credentials, callback) => {
      SessionService.verifyCredentials(credentials, (verifyError) => {
        if (verifyError) {
          dispatch(systemNotificationActions.showNotification('error.api-sessions.401-invalid-current-pwd.message'));
        }

        callback(verifyError);
      });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
